<template>
  <div id="my">
    <div class="container">
      <div class="row">
        <!--left-->
        <div style="width: calc(50% - 21px)">
          <div class="panel panel-success">
            <div class="panel-title">{{ title_l }}</div>
            <!--body-->
            <div class="panel-body panel-height">
              <ul>
                <li
                  v-for="(data1, index) in data_left"
                  :key="index"
                  class="d-flex align-items-center"
                >
                  <input
                    :id="data1.name"
                    v-model="check_val_left"
                    :value="index"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <label :for="data1.name">&ensp;{{ data1.name }}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--center-->
        <div
          class="transfer d-flex justify-content-center align-items-center"
          style="width: 32px; margin: 0 5px"
        >
          <div class="transfer-table">
            <div class="">
              <div class="mt-1">
                <div
                  class="border"
                  style="
                    width: 55px;
                    text-align: center;
                    background: rgb(239, 250, 255);
                    border-radius: 5px;
                  "
                >
                  <span
                    type="button"
                    style="font-size: 14px; margin: 0 5px"
                    @click="left_move()"
                    >選択▶</span
                  >
                </div>
                <div
                  class="border"
                  style="
                    width: 55px;
                    text-align: center;
                    background: rgb(239, 250, 255);
                    margin-top: 5px;
                    border-radius: 5px;
                  "
                >
                  <span
                    type="button"
                    style="font-size: 14px; margin: 0 5px"
                    @click="right_move()"
                    >◀解除</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--right-->
        <div style="width: calc(50% - 21px)">
          <div class="panel panel-success">
            <!--title-->
            <div class="panel-title">{{ title_r }}</div>
            <!--body-->
            <div class="panel-body panel-height">
              <ul>
                <li
                  v-for="(data2, index2) in data_right"
                  :key="index2"
                  class="d-flex align-items-center"
                >
                  <input
                    :id="data2.name"
                    v-model="check_val_right"
                    :value="index2"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <label :for="data2.name"> &ensp;{{ data2.name }}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TransFer',
  props: {
    data_left: Array,
    data_right: Array,
    title_l: String,
    title_r: String
  },
  data() {
    return {
      check_val_left: [],
      check_val_right: []
    }
  },
  methods: {
    left_move: function () {
      this.check_val_left.sort(this.sortNumber)
      this.check_val_left.forEach((item, index, array) => {
        this.data_right.push(this.data_left[item])

        this.data_left.splice(item, 1)
      })

      this.check_val_left = []
    },
    right_move: function () {
      this.check_val_right.sort(this.sortNumber)
      this.check_val_right.forEach((item, index, array) => {
        this.data_left.push(this.data_right[item])

        this.data_right.splice(item, 1)
      })
      this.check_val_right = []
    },
    sortNumber(a, b) {
      return b - a
    }
  }
}
</script>
<style lang="scss" scoped>
li {
  list-style: none;
}
ul {
  padding: 0;
  margin: 0;
}
.container {
  padding: 10px;
  max-width: none;
  background: rgb(222, 224, 226);
}
.panel-title {
  text-align: left;
  padding-left: 10px;
}
.panel-body {
  background: #fff;
  border: 1px solid #999;
  padding: 10px;
  height: 150px;
  overflow-y: auto;
}
.form-check-input {
  margin: 0;
}
</style>
